import { BaseModel } from "src/shared/models";

class MedicineDeliveryDocument extends BaseModel {
    creationDate?: string;
    id?: number;
    name?: string;
    thumbnail?: string;
    uri?: string;
    // this field is used only at client side
    file?: File;
}

export { MedicineDeliveryDocument };
